import { useState } from 'react';

import { toast } from '@webapp/components/Notification'
import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { useQueryVirtualCardPaymentDetails } from '../../models/useQueryVirtualCardPaymentDetails'

export const useVirtualCardPaymentDetailsPresenter = ({
  externalId,
  scaToken,
  onVerificationRequired,
}: {
  externalId: string
  scaToken?: string
  onVerificationRequired?: (scaSessionCode: string) => void
}) => {
  const intl = useProcurifyIntl()

  const [showPaymentDetails, setShowPaymentDetails] = useState(false)

  const { iframeUrl, isFetching, refetch, clearIframeUrl } =
    useQueryVirtualCardPaymentDetails({
      externalId,
      scaToken,
      customCss,
      enabled: showPaymentDetails,
      onVerificationRequired,
      onError: () =>
        toast.error({
          title: intl.formatMessage(messages.fetchingPaymentDetailsErrorToast),
        }),
    })

  return {
    data: {
      iframeUrl: showPaymentDetails ? iframeUrl : undefined,
    },
    commands: {
      revealPaymentDetails: () => {
        if (showPaymentDetails) {
          refetch()
        } else {
          setShowPaymentDetails(true)
        }
      },
      hidePaymentDetails: () => {
        setShowPaymentDetails(false)
        clearIframeUrl()
      },
    },
    states: {
      showLoader: isFetching,
    },
  }
}

const customCss = {
  '.details': {
    color: 'white',
    margin: '0px',
    fontFamily: 'Arial',
  },
  '.details__row': {
    display: 'flex',
    alignItems: 'flex-end',
  },
  '.details__row--card-number': {
    marginBottom: '8px',
  },
  '.details__row--expiry-date': {
    display: 'inline-flex',
  },
  '.details__row--security-code': {
    display: 'inline-flex',
    marginLeft: '16px',
  },
  '.details__label': {
    width: '100px',
  },
  '.details__value': {
    margin: '0px',
    fontWeight: 'bold',
  },
  '.details__button': {
    marginLeft: '8px',
  },
  '.details__button svg': {
    color: 'white',
  },
  '.details__tooltip': {
    padding: '4px',
    paddingLeft: '16px',
    paddingRight: '16px',
    color: 'white',
    fontFamily: 'Arial',
    backgroundColor: '#002E33',
    borderRadius: '4px',
  },
}
